import { useState } from 'react';

export function SqlToggle({ sql }: { sql: string }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const copy = () => {
    navigator.clipboard.writeText(sql);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div>
      <button
        onClick={() => setOpen(!open)}
        className="text-[12px] text-muted-foreground/40 hover:text-muted-foreground/70 transition-colors cursor-pointer flex items-center gap-1"
      >
        <svg
          className={`w-3 h-3 transition-transform duration-150 ${open ? 'rotate-90' : ''}`}
          fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
        SQL
      </button>
      {open && (
        <div className="mt-1.5 relative group">
          <pre className="px-3 py-2.5 rounded-lg bg-[#111] text-[12px] text-muted-foreground/60 font-mono overflow-x-auto border border-primary/10 leading-relaxed">
            {sql}
          </pre>
          <button
            onClick={copy}
            className="absolute top-1.5 right-1.5 px-2 py-1 rounded text-[11px] bg-card border border-primary/10 text-muted-foreground/40 hover:text-foreground opacity-0 group-hover:opacity-100 transition-all cursor-pointer"
          >
            {copied ? 'Copied!' : 'Copy'}
          </button>
        </div>
      )}
    </div>
  );
}
